import ACTION_NAMES from "actions/ACTION_NAMES";
import { generateCreateActionCreator, generateReadOneActionCreator, generateUpdateActionCreator } from "actions/crudActionCreators";
import routes from "actions/routes";

export default {
    create: generateCreateActionCreator(`${routes.API_INVOICE}/order`, ACTION_NAMES.INVOICE),
    readOne: generateReadOneActionCreator(routes.API_INVOICE, ACTION_NAMES.INVOICE),
    pay: generateUpdateActionCreator(routes.API_INVOICE, ACTION_NAMES.INVOICE)
}
